import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

export default class extends Controller {
  static targets = ["enabledToggle"];

  replicationGroupChanged() {
    const select = this.element.querySelector(
      "select[name='voucher_type[auto_replenish_replication_group_id]']"
    );
    const replicationGroupId = select?.value || "";
    const currentForeignKey =
      this.element.querySelector("select[name='voucher_type[auto_replenish_foreign_key]']")
        ?.value || "";

    const foreignKeySelect = this.element.querySelector("#voucher_type_auto_replenish_foreign_key");
    if (foreignKeySelect) {
      foreignKeySelect.disabled = true;
      foreignKeySelect.innerHTML = '<option value="">Loading voucher types...</option>';
    }

    const currentExpirationDays =
      this.element.querySelector("#voucher_type_auto_replenish_expiration_days")?.value || "";

    const params = new URLSearchParams({
      replication_group_id: replicationGroupId,
      current_foreign_key: currentForeignKey,
      current_expiration_days: currentExpirationDays,
    });

    get(`/admin/voucher_types/prepaid_card_type_options?${params}`, {
      responseKind: "turbo-stream",
    });

    this.updateToggleState();
  }

  voucherTypeChanged(event) {
    const display = this.element.querySelector("#voucher_type_auto_replenish_expires_at_display");
    if (!display) return;

    const expiresAt = event.target.selectedOptions[0]?.dataset?.expiresAt;
    display.textContent = expiresAt || "Select a voucher type";
  }

  toggleChanged() {
    if (!this.hasAnyFieldData()) {
      this.enabledToggleTarget.checked = false;
      return;
    }

    if (!this.enabledToggleTarget.checked) {
      this.clearFields();
    }
  }

  fieldChanged(event) {
    if (event.target === this.enabledToggleTarget) return;

    this.updateToggleState();
  }

  updateToggleState() {
    const hasData = this.hasAnyFieldData();
    this.enabledToggleTarget.checked = hasData;
    this.enabledToggleTarget.disabled = !hasData;
  }

  hasAnyFieldData() {
    const repGroup = this.element.querySelector(
      "select[name='voucher_type[auto_replenish_replication_group_id]']"
    )?.value;
    const foreignKey = this.element.querySelector(
      "select[name='voucher_type[auto_replenish_foreign_key]']"
    )?.value;
    const threshold = this.element.querySelector("#voucher_type_auto_replenish_threshold")?.value;
    const batchSize = this.element.querySelector("#voucher_type_auto_replenish_batch_size")?.value;
    const expirationDays = this.element.querySelector(
      "#voucher_type_auto_replenish_expiration_days"
    )?.value;

    return !!(repGroup || foreignKey || threshold || batchSize || expirationDays);
  }

  clearFields() {
    const repGroupSelect = this.element.querySelector(
      "select[name='voucher_type[auto_replenish_replication_group_id]']"
    );
    const foreignKeyContainer = this.element.querySelector("#prepaid-card-type-select");
    const threshold = this.element.querySelector("#voucher_type_auto_replenish_threshold");
    const batchSize = this.element.querySelector("#voucher_type_auto_replenish_batch_size");
    const expirationDays = this.element.querySelector(
      "#voucher_type_auto_replenish_expiration_days"
    );

    if (repGroupSelect) repGroupSelect.value = "";
    if (foreignKeyContainer) {
      foreignKeyContainer.innerHTML =
        '<input type="hidden" name="voucher_type[auto_replenish_foreign_key]" value="">' +
        '<select id="voucher_type_auto_replenish_foreign_key" class="non-selectizable" disabled>' +
        '<option value="">Select a replication group first</option></select>';
    }
    if (threshold) threshold.value = "";
    if (batchSize) batchSize.value = "";
    if (expirationDays) expirationDays.value = "";
  }
}
